export default __webpack_public_path__ + "img/cmjmWOFw.b598ce9f.svg";